import { IObject } from "../../../shared/utils/utils";

export function transformToBackendDatamodelTable(data: any) { // eslint-disable-line
  return {
    columns: data.columns,
    ids: data?.ids,
  };
}

export function transformFromBackendDatamodelTable(backendType: any) { // eslint-disable-line
  return {
    columns: backendType.columns,
    pks: backendType.pks,
    rows: backendType.data?.map((row: IObject) => ({...row, id: row.sygno_id})) || []
  };
}
